export default [
    {
        path: 'interactions',
        name: 'interactions-interactions',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.interactions').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-interactions-list' },
        children: [
            {
                path: '',
                name: 'interactions-interactions-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.interactions').ucFirst();
                    },
                },
                component: () => import('@/views/pages/interactions/interactions/list.vue')
            },
            {
                path: 'create',
                name: 'interactions-interaction-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('interactions::interactions.interaction', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/interactions/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-interaction-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('interactions::interactions.interaction', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/interactions/item.vue'),
            },
        ]
    },
    {
        path: 'interaction-groupings',
        name: 'interactions-interaction-groupings',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.interaction_groupings').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-interaction-groupings-list' },
        children: [
            {
                path: '',
                name: 'interactions-interaction-groupings-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.interaction_groupings').ucFirst();
                    },
                },
                component: () => import('@/views/pages/interactions/groupings/list.vue')
            },
            {
                path: 'create',
                name: 'interactions-interaction-grouping-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('interactions::groupings.grouping', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/groupings/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-interaction-grouping-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('interactions::groupings.grouping', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/groupings/item.vue'),
            },
        ]
    },
    {
        path: 'interaction-categories',
        name: 'interactions-interaction-categories',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.interaction_categories').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-interaction-categories-list' },
        children: [
            {
                path: '',
                name: 'interactions-interaction-categories-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.interaction_categories').ucFirst();
                    },
                },
                component: () => import('@/views/pages/interactions/categories/list.vue')
            },
            {
                path: 'create',
                name: 'interactions-interaction-category-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('interactions::categories.category', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/categories/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-interaction-category-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('interactions::categories.category', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/categories/item.vue'),
            },
        ]
    },
];